<template>
    <div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">라이브 썸네일</td>
                    <td>
                        <div class="" @click="changeType('liveFiles')">
                            <el-upload
                                    class="avatar-uploader content-image live-image"
                                    action=""
                                    list-type="picture-card"
                                    :show-file-list="false"
                                    :file-list="liveFiles"
                                    :auto-upload="false"
                                    :on-change="onlyOnePhotoChange"
                            >
                                <img v-if="hasImage('liveFiles')" :src="liveFiles[0].url" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <div slot="tip" class="el-upload__tip c_danger">720 x 440사이즈에 최적화되어있습니다.</div>
                                <div slot="tip" class="el-upload__tip c_danger">jpg/png 종류의 파일과 10MB 이하의 파일만 가능합니다.
                                </div>
                            </el-upload>
                        </div>
                        <div class="input_error" v-html="validation.firstError('liveFiles') "></div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">리스트 썸네일</td>
                    <td>
                        <div class="" @click="changeType('listFiles')">
                            <el-upload
                                    class="avatar-uploader content-image list-image"
                                    action=""
                                    list-type="picture-card"
                                    :show-file-list="false"
                                    :file-list="listFiles"
                                    :auto-upload="false"
                                    :on-change="onlyOnePhotoChange"
                            >
                                <img v-if="hasImage('listFiles')" :src="listFiles[0].url" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <div slot="tip" class="el-upload__tip c_danger">720 x 360사이즈에 최적화되어있습니다.</div>
                                <div slot="tip" class="el-upload__tip c_danger">jpg/png 종류의 파일과 10MB 이하의 파일만 가능합니다.
                                </div>
                            </el-upload>
                        </div>
                        <div class="input_error" v-html="validation.firstError('listFiles') "></div>
                    </td>
                </tr>
                <tr v-if="!ifDetailPage()">
                    <td class="c_t_title">라이브 등록일</td>
                    <td>
                        {{ streamingData.created_at }}
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">라이브 예정 시간</td>
                    <td>
                        <div>
                            <el-date-picker
                                    v-model="liveTime"
                                    type="datetimerange"
                                    range-separator=""
                                    value-format="yyyy-MM-dd HH:mm"
                                    start-placeholder="시작일"
                                    end-placeholder="종료일"
                                    @change="setFilterDate('liveTime', 'liveTime', liveTime)"
                                    class="el-date-common"
                                    prefix-icon=" "
                                    clear-icon="el-icon-circle-close el-clear-icon"
                            ></el-date-picker>
                            <div class="input_error" v-html="validation.firstError('liveTime') "></div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">라이브 제목</td>
                    <td>
                        <div>
                            <el-input v-model="title" maxlength="20" @input="parentChange('title', title)"></el-input>
                            <div class="input_error" v-html="validation.firstError('title') "></div>
                        </div>
                    </td>
                </tr>
                <tr v-if="!ifDetailPage()">
                    <td class="c_t_title">
                        카메라
                        <el-switch
                                v-model="liveOn"
                                active-text="ON"
                                inactive-text="OFF"
                                @change="toggleChannel(liveOn)">
                        </el-switch>
                    </td>
                    <td>
                        <div>
                            URL : {{ returnStreamingKey(streamingData.c_key, 'url') }}
                        </div>
                        <div class="pt0 pb0">
                            KEY : {{ returnStreamingKey(streamingData.c_key, 'key') }}
                        </div>
                        <div>
                            Live 상태 : {{ liveOn == 0 ? "stop" : "live" }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import elFileMixins from "@/mixins/elFileMixins";
import streamingValidator from "@/mixins/validators/streamingValidator";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import imageOption from "@/mixins/imageOption";

export default {
    name: "StreamingWriteDefaultLayout",
    mixins: [elFileMixins, streamingValidator, imageOption],
    components: {},
    inject: ['streamingWriteSetData', 'streamingStartChannel', 'streamingStopChannel'],
    provide() {
        return {}
    },
    props: {
        streamingData: {
            default: () => {
            }
        },
    },
    data() {
        return {
            imageMaxSize: 1024 * 1024 * 10,
        }
    },
    created() {
        EventBus.$on("StreamingWriteDefaultLayoutValidator", this.validator);
    },
    mounted() {
        this.initData();
        EventBus.$on('setLiveStatus', this.setLiveSwitch);
    },
    beforeDestroy() {
        EventBus.$off('setLiveStatus');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initData() {
            if (this.ifDetailPage()) {
                return false;
            }
            this.title = this.streamingData.s_title;
            this.parentChange('title', this.title);

            this.imageFileTranslate('liveFiles', this.streamingData.LiveImg[0], 720, 440);
            this.imageFileTranslate('listFiles', this.streamingData.ListImg[0], 720, 360);

            this.liveOn = this.streamingData.s_status == 0 ? false : true;
            this.booleanToNum('liveOn', this.liveOn);
            this.liveTime = [this.streamingData.s_live_start, this.streamingData.s_live_end];
            this.setFilterDate('liveTime', 'liveTime', [this.streamingData.s_live_start, this.streamingData.s_live_end]);
        },
        imageFileTranslate(key, files, width = 200, height = 200) {
            let fileWrap = files;
            fileWrap.url = `${fileWrap.org_url}?${this.setImageOptions(width, height, 'png')}`;
            fileWrap.name = fileWrap.org_name;
            if (util.isEmpty(fileWrap.a_idx)) {
                delete fileWrap.a_idx;
            }
            this[key] = [fileWrap];
        },
        ifDetailPage() {
            return util.isEmpty(this.streamingData);
        },
        parentChange(key, value) {
            this.streamingWriteSetData(key, value);
        },
        setFilterDate(classname, key, value) {
            if (!util.isEmpty(value)) {
                this[classname][0] = `${value[0]}`
                this[classname][1] = `${value[1]}`
                this.parentChange(key, value);
                this.parentChange(key + "sd", this[classname][0]);
                this.parentChange(key + "ed", this[classname][1]);
            }
        },
        booleanToNum(key, value) {
            value = value == false ? 0 : 1;
            this.parentChange(key, value);
        },
        hasImage(name) {
            return !util.isEmpty(this[name]);
        },
        validator() {
            let dataKeys = ['title', 'liveTime', 'liveFiles', 'listFiles'];
            this.$validate(dataKeys).then((success) => {
            });
        },
        setLiveSwitch(value) {
            if (value) {
                this.liveOn = true;
            } else {
                this.liveOn = false;
            }
        },
        toggleChannel(value) {
            if (value) {
                this.streamingStartChannel()
            } else {
                this.streamingStopChannel()
            }
        },
        returnStreamingKey(key, type) {
            let stream = key.split('koreanssam_seoul/');
            if (type == 'key') {
                return stream[1];
            } else if (type == 'url') {
                return stream[0] + 'koreanssam_seoul'
            } else {
                return '-'
            }
        },
    },
    watch: {
        'liveFiles': {
            handler: function (val, oldVal) {
                this.streamingWriteSetData('liveFiles', this.liveFiles);
            }
        },
        'listFiles': {
            handler: function (val, oldVal) {
                this.streamingWriteSetData('listFiles', this.listFiles);
            }
        },
    },
}
</script>

<style scoped>

</style>
